import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import icon from './../../assets/images/snackbar-icon-black.png'
import { useDispatch, useSelector } from 'react-redux';
import OtherActions from 'stores/leadbest-official-website/other/actions'
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiAlert-standardSuccess": {
            background: "#dab873",
            alignItems: "center",
            padding: "6px 28px"
        },
        "& .MuiAlert-icon": {
            padding: "0px",
            "& img": {
                width: "16px",
                height: "16px"
            }
        },
        "& .MuiAlert-message": {
            color: "#001229",
            fontSize: "16px"
        }
    }
}))
const CustomizeSnackbar = () => {
    const classes = useStyles()
    const otherSelector = useSelector((state: any) => state.leadbest.other);
    const snackbar = otherSelector.snackbar
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(OtherActions.snackbarLCGRequest({ visible: false }));
    }

    return (
        <Snackbar className={classes.root} open={snackbar.visible} autoHideDuration={6000} onClose={handleClose}>
            <Alert icon={<img src={icon} alt="submit-success-icon" />}>
                <FormattedMessage id={snackbar.message || "snackbar.contact.success"} />
            </Alert>
        </Snackbar>
    )
}
export default CustomizeSnackbar;